<template>
  <div class="authorCenter" :style="ispopshow?'height:100vh;overflow:hidden':''">
    <Header :language="bookdetail.language"></Header>
    <div class="authorBox flexible authorBox-big">
      <authorbar
        :navlist="navlist"
        :bookdetail="bookdetail"
      ></authorbar>
      <div class="writewrap flex mb30">
        <Bread></Bread>
        <router-view :bookdetail="bookdetail" @changePop="changePop" @changeChapter="getBookInfo"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { finishbook, getfinishbook, publishBook } from "apiurl/author";
import { bookInfo } from "apiurl/author";
export default {
  data() {
    return {
      navlist: [],
      bookdetail: {},
      bookId: '',
      ispopshow: false,
    };
  },
  created() {
    this.$nextTick(() => {
      this.getBookInfo();
    });
  },
  watch: {
  },
  methods: {
    // 获取作品信息
    getBookInfo() {
      bookInfo(this.$route.params.id).then(res => {
        if (res.success) {
          this.bookdetail = res.data;
        }
      });
    },
    changePop (data) {
      this.ispopshow = data
    }
  },
  mounted() {
    this.bookId = this.$route.params.id
    this.navlist = [
      { url: "/authorManage/chapterList/" + this.bookId, name: this.$lang('authorCenter.stories.secondaryTitle[0]'), icon: require('@/assets/author/senLevel/information.png')},
      { url: "/authorManage/contract/" + this.bookId, name: this.$lang('authorCenter.stories.secondaryTitle[1]'), icon: require('@/assets/author/senLevel/Contract.png')},
      { url: "/authorManage/completing/" + this.bookId, name: this.$lang('authorCenter.stories.secondaryTitle[2]'), icon: require('@/assets/author/senLevel/Completing.png')},
      { url: "/authorManage/reward/" + this.bookId, name: this.$lang('authorCenter.stories.secondaryTitle[3]'), icon: require('@/assets/author/senLevel/Reward.png')},
      { url: "/authorManage/chapterdel/" + this.bookId, name: this.$lang('authorCenter.stories.secondaryTitle[4]'), icon: require('@/assets/author/senLevel/Delate.png')},
    ]
  }
};
</script>

<style lang="scss" scoped>
  @import "@/styles/author.scss";
</style>
